import { render } from "./Cover.vue?vue&type=template&id=326350b6&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=326350b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326350b6"]])

export default __exports__